import { ROUTES } from "../../constants/routes";
import { Component, inject, signal } from "@angular/core";
import { RouterLink } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { Navbar } from "../../components/navbar/navbar";
import { Breadcrumb } from "../../components/breadcrumb/breadcrumb";
import { Footer } from "../../components/footer/footer";
import { SeoService } from "../../services/seo.service";
import { SITE } from "../../constants/site";
import { breadcrumbSchema } from "../../helpers/structured-data";

@Component({
  selector: "app-book-a-call",
  imports: [RouterLink, FormsModule, Breadcrumb, Navbar, Footer],
  templateUrl: "./book-a-call.html",
  styleUrl: "./book-a-call.scss"
})
export class BookACall {
  readonly routes = ROUTES;
  private readonly seo = inject(SeoService);
  readonly site = SITE;

  readonly submitted = signal(false);

  model = {
    name: "",
    email: "",
    company: "",
    phone: "",
    slot: "",
    notes: ""
  };

  readonly expectations = [
    "A 30 minute live walkthrough of deceased verification, tailored to your use case",
    "Answers on data freshness, coverage, matching accuracy and pricing",
    "A look at both the file upload workflow and the real time API",
    "No pressure and no obligation. We only follow up if you ask us to"
  ];

  readonly slots = [
    "Morning (9am to 12pm PT)",
    "Midday (12pm to 3pm PT)",
    "Afternoon (3pm to 6pm PT)"
  ];

  submit(): void {
    this.submitted.set(true);
  }

  ngOnInit(): void {
    this.seo.apply({
      title: "Book a Call | Free VerifyDeceased Consultation",
      description:
        "Schedule a free consultation with the VerifyDeceased team. Get a live walkthrough and ask about data freshness, coverage and pricing, with no obligation.",
      path: "/book-a-call",
      keywords:
        "book a call VerifyDeceased, schedule death verification demo, deceased verification consultation, free consultation death data",
      structuredData: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Book a call", path: "/book-a-call" }
        ])
      ]
    });
  }
}
